import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { LeadSource } from "services/redux/sales/corporate/leadDetails/action";
import {
  pocSiteType,
  pocSubSiteType,
  pocType,
} from "services/redux/sales/corporate/pocDetails/action";
import {
  leadCategories,
  getSupplyDropDown,
} from "services/redux/sales/corporate/categoryDetails/action";
import {
  locationArea,
  locationCity,
  locationPinCode,
  locationState,
  locationType,
  locationZone,
} from "services/redux/sales/corporate/locations/action";
import EditSupply from "./editSupply";
import { createSupplyLead } from "services/redux/sales/corporate/action";
import { getCurrentLocation } from "services/redux/sales/currentLocation/action";
import { excelUploadUrl } from "services/redux/fileUpload/action";
import { getDetails } from "services/redux/sales/preSaleListing/action";
import { editSupplyLeadSubmit } from "services/redux/sales/editLead/action";

const mapStateToProps = (state) => ({
  sourceData: state.LeadDetailsReducer.LeadSources,
  pocTypeData: state.pocTypesReducer.pocTypeData,
  pocSiteTypeData: state.pocTypesReducer.pocSiteTypeData,
  pocSubSiteTypeData: state.pocTypesReducer.pocSubSiteTypeData,
  leadCategory: state.categoryDetlReducer.leadCategory,
  supDropDownData: state.categoryDetlReducer.supDropDownData,
  cities: state.locationReducer.cities,
  zones: state.locationReducer.zones,
  areas: state.locationReducer.areas,
  state: state.locationReducer.state,
  pincodeData: state.locationReducer.pincodeData,
  locTypesData: state.locationReducer.locTypesData,
  latlng: state.currentLocationReducer.latlng,
  toastMsg: state.toastReducer,
  viewDetails: state.preSalesListReducer.viewDetails,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      LeadSource,
      pocType,
      leadCategories,
      locationCity,
      locationZone,
      locationArea,
      locationType,
      locationPinCode,
      locationState,
      createSupplyLead,
      pocSiteType,
      pocSubSiteType,
      getSupplyDropDown,
      getCurrentLocation,
      excelUploadUrl,
      editSupplyLeadSubmit,
      getDetails,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(EditSupply);
